export const findRefsInVNode = async (refIds, vnode, options = {}) => {
  const mergedOptions = {
    // set defaults
    refElements: {},
    level: 0,

    // and combine with existing
    ...options,
  };

  const { refElements, level } = mergedOptions;

  // find new refs in current vnode
  let foundRefElements = Object.fromEntries(
    refIds.map(refId => [refId, refElements[refId] || vnode.$refs[refId]])
  );

  const checkElementsFound = () => Object.values(foundRefElements).every(el => el !== undefined);

  if (
    checkElementsFound() ||
    // has no further children
    (level > 0 && !vnode.$children.length)
  ) {
    return foundRefElements;
  }

  // find refs in children from level 0 and below
  if (vnode.$children.length && level >= 0) {
    /* const allElementsFound = */ vnode.$children.some(async child => {
      foundRefElements = await findRefsInVNode(refIds, child, {
        refElements: foundRefElements,
        level: level + 1,
      });
      return checkElementsFound();
    });

    // found missing elements in children
    // if (allElementsFound) return foundRefElements;
  }

  // find refs in parents of level 0
  if (level <= 0 && vnode !== vnode.$root) {
    if (level === 0 || vnode.$parent === vnode) {
      // if the parent is not mounted yet $parent is the same as the current component
      // wait one more tick from level 0 to be sure that parents are mounted
      await vnode.$nextTick();
    }

    foundRefElements = await findRefsInVNode(refIds, vnode.$parent, {
      refElements: foundRefElements,
      level: level - 1,
    });
  }

  return foundRefElements;
};

export function disablePageScrollWhileSwipingIOS(el) {
  let touchingCarousel = false;
  let touchStartCoords;

  document.body.addEventListener('touchstart', e => {
    touchingCarousel = el.compareDocumentPosition(e.target) & Node.DOCUMENT_POSITION_CONTAINS;

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY,
    };
  });

  document.body.addEventListener(
    'touchmove',
    e => {
      if (!(touchingCarousel && e.cancelable)) return;

      const moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y,
      };

      if (Math.abs(moveVector.x) > 7) e.preventDefault();
    },
    { passive: false }
  );
}
